import React from 'react';

import { Switch, Route } from 'react-router-dom';

import {
  GERMAN,
  ENGLISH_UK,
  ENGLISH_US,
  FRENCH_FRANCE,
} from 'constants/locales';

import ConnectedChildren from './ConnectedChildren';

const LanguageSwitch = (props) => {
  const buildChildren = (locale) => () => (
    <ConnectedChildren locale={locale} {...props} />
  );

  return (
    <Switch>
      <Route
        path={`/${GERMAN.toLowerCase()}/`}
        component={buildChildren(GERMAN)}
      />
      <Route
        path={`/${ENGLISH_UK.toLowerCase()}/`}
        component={buildChildren(ENGLISH_UK)}
      />
      <Route
        path={`/${ENGLISH_US.toLowerCase()}/`}
        component={buildChildren(ENGLISH_US)}
      />
      <Route
        path={`/${FRENCH_FRANCE.toLowerCase()}/`}
        component={buildChildren(FRENCH_FRANCE)}
      />
      <Route component={buildChildren(GERMAN)} />
    </Switch>
  );
};

export default LanguageSwitch;
